import React from "react";
import { CareManagerSection } from "../../../components/super-admin-dashboard";

const CareManagerTab = ({ scope }) => {
  return <CareManagerSection scope={scope} title="Care Manager Overview" />;
};

export default CareManagerTab;
